import { translate as t } from '@thoughtspot/i18n';
import { Table } from '@thoughtspot/radiant-react/widgets/table';
import { Colors, Typography, } from '@thoughtspot/radiant-react/widgets/typography';
import React from 'react';
import { Horizontal } from "../../../../utils/layouts";
import { dataColumnsClusterSnapshots, prepareClusterSnapshotsData, } from '../cluster-status-utils';
import styles from './cluster-snapshot-tables.module.scss';
export const ClusterSnapshotTable = ({ listSnapshotData, }) => {
    const snapshotData = prepareClusterSnapshotsData(listSnapshotData);
    const renderContent = () => (React.createElement("div", { className: styles.table, "data-testid": "cluster-snapshot-table-id" },
        React.createElement(Typography, { variant: "h4", color: Colors.base, noMargin: true }, t('adminUI.messages.CLUSTER_DETAIL_SNAPSHOT_TITLE')),
        React.createElement(Table, { className: styles.tableComponent, data: snapshotData, columns: dataColumnsClusterSnapshots }),
        snapshotData && (React.createElement(Horizontal, { className: styles.tableFooter },
            React.createElement(Typography, { variant: "body-normal", color: Colors.base, noMargin: true }, t('pagination_footer', {
                total: snapshotData.length,
            }))))));
    return renderContent();
};
//# sourceMappingURL=cluster-snapshot.container.js.map